var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrafficCone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.125 192H149.875L111.625 288H400.375L362.125 192ZM289.75 10.125C287.25 4 281.375 0 274.875 0H237.125C230.625 0 224.75 4 222.25 10.125L175.375 128H336.625L289.75 10.125ZM480 448H464L425.75 352H86.25L48 448H32C14.327 448 0 462.327 0 480V480C0 497.673 14.327 512 32 512H480C497.673 512 512 497.673 512 480V480C512 462.327 497.673 448 480 448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficCone);
export default __webpack_public_path__ + "static/media/traffic-cone.2440eb8e4f997ba48fbe16f3c402e845.svg";
export { ForwardRef as ReactComponent };